const BrandPill = ({ brand = "not set" }) => {
  const brandStyles = {
    zeropa: "bg-pink-500 border-pink-500 text-white",
    argid: "bg-blue-500 border-blue-500 text-blue-50",
    madad: "bg-yellow-500 border-yellow-500 text-yellow-900",
    default: "bg-gray-500 border-gray-500 text-gray-50", // Default styling
  };

  const appliedStyles = brandStyles[brand] || brandStyles.default;

  return (
    <>
      <div
        data-open="true"
        data-shape="pill"
        className={`relative inline-flex w-max items-center border select-none font-sans font-medium rounded-md data-[shape=pill]:rounded-full text-xs p-0.2 shadow-sm bg-transparent ${appliedStyles}`}
      >
        <span className="font-sans text-current leading-none my-0.5 mx-1.5 uppercase">
          {brand}
        </span>
      </div>
    </>
  );
};

export default BrandPill;
